import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from 'react';
import { prepareProps } from '../../../utils/propUtils';
import { PropsWithoutChildren } from '../../../utils/utilityTypes';
import { classes } from '../../../utils/utils';
import styles from './BaseDialogTabTitle.module.css';
export type BaseDialogTabTitleProps<TTabName extends string> = PropsWithoutChildren<{
  name: TTabName;
  title: string;
  selected: boolean;
  onSelected?: (name: TTabName) => void;
}>;
export const BaseDialogTabTitle = React.memo(props => {
  const $ = _c(14);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    name,
    selected,
    title,
    onSelected
  } = t0;
  let t1;
  if ($[2] !== name || $[3] !== onSelected || $[4] !== selected) {
    t1 = () => {
      if (!selected) {
        onSelected?.(name);
      }
    };
    $[2] = name;
    $[3] = onSelected;
    $[4] = selected;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleClick = t1;
  const t2 = selected ? styles.selectedTabTitle : null;
  let t3;
  if ($[6] !== t2) {
    t3 = classes(styles.tabTitle, t2);
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== title) {
    t4 = <div className={styles.tabTitleText} data-testid="BaseDialogTabTitle.TitleText">{title}</div>;
    $[8] = title;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== handleClick || $[11] !== t3 || $[12] !== t4) {
    t5 = <button type="button" className={t3} onClick={handleClick}>{t4}</button>;
    $[10] = handleClick;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}) as <TTabName extends string>(props: BaseDialogTabTitleProps<TTabName>) => React.JSX.Element;